import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '@/components/usePageTitle';
import { SearchResults } from '@/features/ops/GlobalSearch';

export const Route = createFileRoute('/_staff/staff/search')({
  validateSearch: (search: Record<string, unknown>) => ({ q: typeof search.q === 'string' ? search.q : undefined }),
  component: SearchPage,
});

function SearchPage() {
  const { t } = useTranslation('ops');
  const { q } = Route.useSearch();
  usePageTitle(t('search.title'));
  return <SearchResults q={q ?? ''} />;
}
